import i18n from "./i18n";
import groupBy from "lodash/groupBy";
//import taxonomy from "@infoshareplus/scanstation-config/dist/customer/demo/taxonomy.json";
import {taxonomy} from '../config';

/**
 * Previously, the ID was stored within the service area and evidence type objects. To remain backwardly compatible,
 * add the ID into a clone of these objects before returning them.
 *
 * Rather than mutating the taxonomy, the ID is added to a clone of the objects therein.
 *
 * @param original
 * @param id
 * @returns {{}}
 */
const addIdentity = (original, id) => {
  return {...original, id};
};

const sortByLabel = entities => {
  return entities.sort((entity1, entity2) => {
    return entity1.label.localeCompare(entity2.label);
  });
};

export default {
  DEFAULT_CATEGORY_NAME: 'defaultCategory',

  getServiceArea(serviceAreaId) {
    const serviceArea = taxonomy.serviceAreas[serviceAreaId];
    if (serviceArea) {
      return i18n.translate(addIdentity(serviceArea, serviceAreaId));

    } else {
      console.warn(`Service area with ID '${serviceAreaId}' not found`);
    }
  },

  getAllServiceAreas() {
    const unsortedServiceAreas = Object.keys(taxonomy.serviceAreas).map(serviceAreaId => {
      return this.getServiceArea(serviceAreaId)
    });
    return sortByLabel(unsortedServiceAreas);
  },

  /**
   * Get an evidence type object from the taxonomy
   * @param serviceArea either a service area object or the ID thereof
   * @param evidenceTypeId the ID of an evidence type
   * @returns {*|T | undefined} an evidence type object
   */
  getEvidenceType(serviceArea, evidenceTypeId) {
    const evidenceType = serviceArea && serviceArea.evidenceTypes.find(evidenceType =>
      evidenceType.code === evidenceTypeId);

    if (evidenceType) {
      const evidenceTypeWithId = addIdentity(evidenceType, evidenceTypeId);
      return i18n.translate(evidenceTypeWithId, ['label', 'category']);

    } else {
      console.warn(`Evidence type with ID '${evidenceTypeId}' not found`);
    }
  },

  /**
   * Get all evidence types in a service area
   * @param serviceArea
   * @returns {Object} evidence types grouped by category
   */
  getAllEvidenceTypes(serviceArea) {

    const evidenceTypes = serviceArea.evidenceTypes.map(evidenceType => {
      const evidenceTypeWithId = addIdentity(evidenceType, evidenceType.code);
      return i18n.translate(evidenceTypeWithId, ['label', 'category']);
    });

    const groupedEvidenceTypes = groupBy(evidenceTypes, evidenceType => {
      return evidenceType.category || this.DEFAULT_CATEGORY_NAME;
    });

    // Sort the evidence types by label within each group
    for (let category in groupedEvidenceTypes) {

      if (groupedEvidenceTypes.hasOwnProperty(category)) {
        const unsortedEvidenceTypes = groupedEvidenceTypes[category];
        groupedEvidenceTypes[category] = sortByLabel(unsortedEvidenceTypes);
      }
    }
    return groupedEvidenceTypes;
  }
}
